module.exports = __webpack_public_path__ + "img/RSVP.313a4b85.svg";